export default __webpack_public_path__ + "static/media/Group 3415 (1).7ac2192d.svg";